import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { AppDataProvider, useAppData } from "./data/AppDataContext";
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Queue from "./pages/Queue";
import NewPlan from "./pages/NewPlan";
import CompletedPayments from "./pages/CompletedPayments";
import CustomerPublic from "./pages/CustomerPublic";
import CustomerPublicShort from "./pages/CustomerPublicShort";
import PlanManagement from "./pages/PlanManagement";
import SerialManagement from "./pages/SerialManagement";
import FindAccount from "./pages/FindAccount";
import "./styles.css";

function Toast() {
  const { toast } = useAppData();
  if (!toast) return null;
  return <div className="pl-toast">{toast}</div>;
}
function RoleRoute({ allow, children }) {
  const { user } = useAuth();
  const role = user?.role || "admin";
  if (!allow.includes(role)) return <Navigate to="/customers" replace />;
  return children;
}
function ProtectedLayout() {
  const { isAuthenticated, ready } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!ready) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;

  return (
    <AppDataProvider>
      <div className="pl-app">
        <div className="pl-mobile-topbar">
          <button className="pl-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
            <Menu size={22} />
          </button>
          <img src="/oticLogo.png" alt="Otic" style={{ width: 22, height: 22, objectFit: "contain", borderRadius: 5 }} />
          <span style={{ fontWeight: 700, fontSize: 14 }}>Payment Plans</span>
        </div>

        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main className="pl-main">
       <Routes>
          <Route path="/" element={<RoleRoute allow={["admin"]}><Dashboard /></RoleRoute>} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route path="/queue" element={<RoleRoute allow={["admin"]}><Queue /></RoleRoute>} />
          <Route path="/new-plan" element={<RoleRoute allow={["admin", "team_lead", "manager"]}><NewPlan /></RoleRoute>} />
          <Route path="/completed-payments" element={<RoleRoute allow={["admin"]}><CompletedPayments /></RoleRoute>} />
          <Route path="/serials" element={<RoleRoute allow={["admin", "manager"]}><SerialManagement /></RoleRoute>} />
          <Route path="/plans" element={<RoleRoute allow={["admin", "manager"]}><PlanManagement /></RoleRoute>} />
        </Routes>
        </main>
        <Toast />
      </div>
    </AppDataProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Public, unauthenticated customer-facing routes -- must NOT
              go through ProtectedLayout, since customers are never logged in */}
          <Route path="/customer/:token" element={<CustomerPublic />} />
          <Route path="/customer/:shortCode/:slug" element={<CustomerPublicShort />} />
          <Route path="/find-my-account" element={<FindAccount />} />

          <Route path="/*" element={<ProtectedLayout />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}